import { Switch } from 'antd';
import ScenarioFilter from '../ScenarioFilter/ScenarioFilter';
import { useContext } from 'react';
import { PricingAnalyticsDataContext } from 'contexts/PricingAnalyticsContext';
import LensConfigManger from '../LensConfigManager/LensConfigManger';
import { LenseAttribute, LenseConfig } from 'types/pricingSimulator';
import { filterOutDisplayOnlyAttributes } from 'utils/helperMethods';

const AnalyticsActions = () => {
    const {
        selectedReportInfo,
        showPercentageChange,
        setShowPercentageChange,
        updateReportProperty,
        applyFilterObject,
        availableFilters,
        allCheckedAttribute,
        setAllCheckedAttribute,
        allSelectedValueForAllAttribute,
        setAllSelectedValueForAllAttribute,
        setApplyFilterObject,
        resetFilterObject,
        setShowIsEditedRecords,
        lenseConfigLoading,
        saveFilterConfig,
    } = useContext(PricingAnalyticsDataContext);

    const disableSearchFilterButton = false; // commonLoader || pollingStatuses.includes(selectedScenarioInfo?.status || '');

    const onFilterSaveClickHandler = (resultObj: any) => {
        setAllCheckedAttribute(resultObj.allCheckedAttribute);
        setAllSelectedValueForAllAttribute(resultObj.allSelectedValueForAllAttribute);
        setShowIsEditedRecords(resultObj?.showIsEditedRecords);
        setApplyFilterObject(resultObj.applyFilterObject);

        saveFilterConfig(resultObj);
    };

    return (
        <div className={`flex items-center gap-2  `}>
            <div className="flex gap-1 items-center">
                <span className="text-promoColour font-xxs">Abs</span>
                <Switch checked={showPercentageChange} onChange={(checked) => setShowPercentageChange(checked)} />
                <span className="text-promoColour font-xxs">%</span>
            </div>
            <div className="flex justify-center items-center">
                <span className="mr-2">Select KPI's</span>
                <LensConfigManger
                    buttonName={'Multiple Selections'}
                    initialConfigDetails={filterOutDisplayOnlyAttributes(selectedReportInfo?.baseKPIs?.kpiConfig || [])}
                    onSubmitHandler={(updatedDetails: LenseConfig[]) => {
                        if (selectedReportInfo) {
                            const updatedKpis: number[] = [];
                            updatedDetails?.forEach((c: LenseConfig) => {
                                c.attributes.forEach((a: LenseAttribute) => {
                                    if (a.isSelected) {
                                        updatedKpis.push(a.attributeId);
                                    }
                                });
                            });
                            updateReportProperty('baseKPIs', {
                                ...selectedReportInfo?.baseKPIs,
                                kpiConfig: updatedDetails,
                                selectedKPIs: updatedKpis.filter((value, index, self) => self.indexOf(value) === index),
                            });
                        }
                    }}
                    showAttributePanelToTheRight={false}
                    placeHolderLabel="Search Kpis..."
                    saveButtonLabel="Add Selected"
                    noOutputCall={true}
                    disabled={lenseConfigLoading}
                />
            </div>
            <ScenarioFilter
                disabled={disableSearchFilterButton}
                availableFilters={availableFilters}
                allCheckedAttribute={allCheckedAttribute}
                allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                applyFilterObject={applyFilterObject}
                resetFilterObject={resetFilterObject}
                scenarioId={selectedReportInfo?.baseScenario?.scenarioId || 0}
                onSubmitHandler={onFilterSaveClickHandler}
                showAttributePanelToLeft={true}
                hideShowEditedRecordCheckbox
            />
        </div>
    );
};

export default AnalyticsActions;
